export default __webpack_public_path__ + "static/extreme_networks-4975180e732232609f5212b8a972c5bf.jpg";